/**
 * REST production endpoints — tester-driven device provisioning.
 *
 *   POST /production/secrets   — generate a fresh device secret key
 *   POST /production/devices   — provision a new device (tester flow)
 *
 * Guarded by the production_test role. Replaces the admin-only manual
 * pre-registration path (POST /admin/production/devices) as the primary
 * way to bring a device into existence — the admin path is kept as a
 * break-glass fallback.
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { Iso8601Schema } from '../common/timestamp.js';
// ── POST /production/secrets ─────────────────────────────────────────────
export const TesterSecretGenerateResponse = z.object({
    /** 13 chars: 5 letters (A-Za-z) + 5 digits + 3 specials from !@#$%^&*+-=?, shuffled. */
    secretKey: z.string().length(13),
});
// ── POST /production/devices ─────────────────────────────────────────────
export const TesterDeviceKindSchema = z.enum(['stair', 'ceiling', 'lift']);
export const TesterProvisionDeviceBody = z.object({
    serialNumber: z.string().min(3).max(64),
    secretKey: z.string().length(13),
    deviceKind: TesterDeviceKindSchema,
    /** Optional link to the test report submitted just before provisioning. */
    testReportId: UuidSchema.optional(),
});
export const TesterProvisionDeviceResponse = z.object({
    deviceIdentityId: UuidSchema,
    deviceId: UuidSchema,
    serialNumber: z.string(),
    lifecycleState: z.literal('tested'),
    createdAt: Iso8601Schema,
});
//# sourceMappingURL=production.js.map